module.exports = __webpack_public_path__ + "static/img/img-ptfw5x.0d2b479.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw5x.png
// module id = yuJT
// module chunks = 0